import { useEffect } from "react";
import { useState } from "react";
import { Line } from "react-chartjs-2";
import api from "../../../services/api";

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top" as const,
    },
  },
};

export const data = {
  labels: [],
  datasets: [
    {
      label: "Vencimentos",
      data: [],
      borderColor: "rgb(255, 99, 132)",
      backgroundColor: "rgba(255, 99, 132, 0.5)",
      tension: 0.1,
      fill: true
    },
  ],
};

interface ChartDTO {
  dueDay: string;
  count: number;
}

const CampaignChartDates = () => {
  const [graphData, setGraphData] = useState<any>();
  const [hasError, setError] = useState<boolean>();

  useEffect(() => {
    const init = async () => {
      try {
        const { data: result } = await api.get("/campaigns/chart/day");

        if (!result.success) {
          setError(true);
          return;
        }

        if (!result.item) {
          setError(true);
          return;
        }

        setGraphData(result.item);

        data.labels = result.item.map((c: ChartDTO) => {
          return [`Dia ${c.dueDay}`, `${c.count} ${c.count == 1 ? 'pessoa' : 'pessoas'}`];
        });
        data.datasets[0].data = result.item.map((c: ChartDTO) => {
          return c.count;
        });
      } catch (ex) {
        console.log(ex);
        setGraphData(null);
        setError(true);
      }
    };
    init();
  }, []);

  return (
    <>
      <h3 className="uk-text-center uk-text-bold">Dia Do Vencimento</h3>
      <div className="uk-width-1@m uk-flex uk-flex-center">
          {hasError && hasError === true ? (
            <span className="uk-label uk-label-danger uk-text-center">
              Gráfico não disponível
            </span>
          ) : !graphData ? (
            <div className="uk-text-center" uk-spinner="true; ratio:2">
              Carregando...
            </div>
          ) : (
            <Line data={data} options={options} />
          )}
      </div>
    </>
  );
};

export default CampaignChartDates;
